import React, { useState } from "react";
import { createTask } from "../services/api";

export default function AddTaskForm({ onTaskAdded }) {
  const [form, setForm] = useState({ title: "", description: "", due_date: "" });
  const token = localStorage.getItem("token");

  const handleChange = (e) => setForm({ ...form, [e.target.name]: e.target.value });

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      const res = await createTask(form, token);
      onTaskAdded(res.data); // update parent list
      setForm({ title: "", description: "", due_date: "" });
    } catch (err) {
      alert("Error creating task");
      console.error(err);
    }
  };

  return (
    <div className="bg-white p-6 rounded-xl shadow-lg border border-gray-100">
      <h2 className="text-2xl font-bold mb-4 text-gray-800">
        Add New Task
      </h2>
      <form onSubmit={handleSubmit} className="flex flex-col gap-3">
        <input
          type="text"
          name="title"
          placeholder="Task title"
          value={form.title}
          onChange={handleChange}
          className="border p-2 rounded"
          required
        />
        <textarea
          name="description"
          placeholder="Description"
          value={form.description}
          onChange={handleChange}
          className="border p-2 rounded"
        />
        <input
          type="datetime-local"
          name="due_date"
          value={form.due_date}
          onChange={handleChange}
          className="border p-2 rounded"
        />
        <button
          type="submit"
          className="bg-gradient-to-r from-blue-600 to-purple-600 text-white py-3 px-6 rounded-lg hover:from-blue-700 hover:to-purple-700 transition font-semibold shadow-md"
        >
          Add Task
        </button>
      </form>
    </div>
  );
}
